import { render, staticRenderFns } from "./ChallengeOrganisation.vue?vue&type=template&id=6600b4e2&scoped=true&"
import script from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"
export * from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeOrganisation.vue?vue&type=style&index=0&id=6600b4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600b4e2",
  null
  
)

export default component.exports